import { Directive } from '@angular/core';
import { PageSize, SortMod } from '@marmon/shared/types/pagination';
import { BehaviorSubject, Subject } from 'rxjs';

@Directive()
export class TableBaseComponent<ObjectType extends object> {
	/**
	 * the column keys that may need to be provided during the implementation of the
	 * paginated page. Used for taiga tables to leverage some additional functionality
	 * with sorting and filtering.
	 */
	protected readonly columnKeys: string[] = [];

	protected readonly size$ = new BehaviorSubject<PageSize>(10);
	protected readonly loading$ = new BehaviorSubject(true);
	protected readonly refetch$ = new Subject<void>();
	protected readonly search$ = new BehaviorSubject<string>('');

	protected readonly direction$ = new BehaviorSubject<SortMod>(1);
	protected readonly sorter$ = new BehaviorSubject<keyof ObjectType | null>(
		null,
	);

	readonly onSortChange = (event: {
		sortKey: keyof ObjectType | null;
		sortDirection: SortMod;
	}) => {
		if (event.sortKey) {
			this.sorter$.next(event.sortKey);
		}

		this.direction$.next(event.sortDirection);
	};
}
